import React from 'react';
import { BookOpen } from 'lucide-react';
import { format } from 'date-fns';
import { nb } from 'date-fns/locale';

interface SourceArticle {
  url: string;
  title: string;
  domain: string;
  publicationDate: string;
}

interface ArticleSourcesProps {
  sources?: SourceArticle[];
  tags?: string[];
}

export const ArticleSources: React.FC<ArticleSourcesProps> = ({ sources, tags }) => {
  console.log('[ArticleSources] Render with props:', {
    hasSources: !!sources,
    sourceCount: sources?.length ?? 0,
    sources,
    tags,
  });

  // Show sources whenever we actually have source articles
  // (RAG-artikler er i praksis de eneste som har kilder lagret)
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="flex items-center gap-2 mb-4">
        <BookOpen className="w-5 h-5 text-muted-foreground" />
        <h3 className="text-lg font-semibold text-foreground">
          Kilder brukt i denne artikkelen
        </h3>
      </div>
      
      <div className="space-y-3">
        {sources.map((source, index) => {
          let formattedDate = '';
          try {
            const date = new Date(source.publicationDate);
            formattedDate = format(date, 'd. MMMM yyyy', { locale: nb });
          } catch (e) {
            formattedDate = source.publicationDate;
          }

          return (
            <div 
              key={index} 
              className="flex flex-col gap-1 p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
            >
              <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-primary hover:underline"
              >
                {source.title}
              </a>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span className="font-medium">{source.domain}</span>
                <span>•</span>
                <span>{formattedDate}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
